import axios from 'axios'

export default class CompanyApplicant {
  togglePeriod() {
    $(document).ready(function () {
      $('[data-role="period"]').on('click', function(){
        let isEnableChangeDate = $(this).val() === '0';
        let periodName = $(this).data('period');
        let datetimeEle = $(`[data-role="datetime"][data-period="${periodName}"]`);
        datetimeEle.prop('disabled', !isEnableChangeDate);
        if (!isEnableChangeDate) {
          datetimeEle.val('')
        }
      });
      $.each($('[data-role="period"]:checked'), function (index, ele) {
        let isEnableChangeDate = $(this).val() === '0';
        let periodName = $(this).data('period');
        $(`[data-role="datetime"][data-period="${periodName}"]`).prop('disabled', !isEnableChangeDate)
      })
    })
  }

  checkAtLeastOneSelected(form) {
    var inputs = form.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.type === 'checkbox') {
        if (input.checked) {
          return true;
        }
      }
    }
    alert(gon.alert_text);
    return false;
  }

  getSearchSessionId(){
    const url = new URLSearchParams(window.location.search);
    return url.get('searchsession');
  }

  checkAtLeastOneMailMemberExists(event) {
    $.ajax({
      async: false,
      method: 'post',
      url: Routes.is_mail_member_exists_resume_searches_path(gon.locale, { searchsession: this.getSearchSessionId() }),
      success: function(res) {
        if (res.error != '') {
          event.preventDefault();
          alert(res.error);
          return false;
        }
      },
      fail: function(err) {
        console.log(err);
      }
    })
  }

  getTemplate(event){
    event.preventDefault();
    let form = event.target
    $.ajax({
      dataType: "json",
      url: form.action,
      method: form.method,
      data: $(form).serializeArray(),
      success: function (res) {
        $('#message_body').val(res.body);
        $('#message_subject').val(res.subject)
        $(form).find(':submit').prop('disabled', false);
      },
      error: function (error) {
        console.log(error)
        $(form).find(':submit').prop('disabled', false);
      }
    })
  }

  getTemplateSendAgain(template_id, company_profile_id){
    axios({
      method: 'get',
      url: Routes.get_template_company_profile_search_company_applicants_path({company_profile_id: company_profile_id, template_id: template_id}),
      data: {
        company_profile_id: company_profile_id,
        template_id: template_id,
      }
    }).then((res) => {
      if (res.status == 200) {
        $('#message_body2').val(res.data.body);
        $('#message_subject2').val(res.data.subject);
        $('#message_subject2').attr('data-overwrite', 'overwrite');
      }
    })
  }

  updateStatus(id, target) {
    let interviews = ['first_interview', 'second_interview', 'third_interview', 'forth_interview']
    let prev_value = $(target).attr('data-before-change')

    if (interviews.includes(prev_value) && !interviews.includes(target.value)) {
      this.hasArrangement(id, (is_applicant_has_arrangement) => {
        if (is_applicant_has_arrangement) {
          $('.update-status-application').modal('show')
        } else {
          this.updateStatusAndView(id, target, true)
        }

        $('.update-status-application').on('click', '.btn-primary', () => {
          this.updateStatusAndView(id, target, true)
        })
        $('.update-status-application').on('click', '.btn-outline-secondary', () => {
          $(target).val(prev_value)
        })
        $('.update-status-application').on('hidden.bs.modal', () => {
          $('.update-status-application').off('click')
        })
      })
    } else {
      this.updateStatusAndView(id, target, null)
    }

    CompanyOfferReport.showButtonCompanyOfferReport(target);
  }

  updateStatusAndView(id, target, isDeleteArrangement) {
    this.statusUpdateRequest(id, target, isDeleteArrangement)
    $(target).attr('data-before-change', target.value)
  }

  hasArrangement(id, callback) {
    $.ajax({
      url: Routes.check_applicant_has_arrangement_interviews_interview_arrangements_path(),
      data: { member_application_id: id },
      success: (response) => { callback(response.is_applicant_has_arrangement) },
      error: (_) => { alert('System error'); return }
    })
  }

  statusUpdateRequest(id, target, isDeleteArrangement) {
    $.ajax({
      url: Routes.update_member_status_company_applicants_path(gon.locale),
      method: 'post',
      data: {
        id,
        value: target.value,
        is_delete_arrangement: isDeleteArrangement
      },
      success: (response) => {
        $(target).siblings('span').html(response.message)
      },
      error: () => {
        alert('There was an error while updating status in applicants list.');
      }
    })
  }

  updateCurrency(target, default_value = '', is_hourly_options = false) {
    let currency_options;
    if(target.value === '') {
      currency_options = `<option value=${default_value}>--------</option>`
    } else {
      let currency_id = parseInt(target.value).toString === target.value ? parseInt(target.value) : target.value;
      let currency_list
      if(is_hourly_options) {
        currency_list = gon.hourly_currency_list[currency_id].list;
      } else {
        currency_list = gon.currency_list[currency_id].list;
      }
      currency_options = currency_list.map(function (ele) {
        if (!ele) {
          return `<option value=''>${gon.views.shared.please_choose}</option>`
        }
        return `<option value='${ele[1]}'>${ele[0]}</option>`
      });
    }
    $(target).parents('.salary-select--dependent').find('.salary-value').html(currency_options)
  }
}
